import { render, staticRenderFns } from "./AnalyticalTransferReport.vue?vue&type=template&id=22627ad8&"
import script from "./AnalyticalTransferReport.vue?vue&type=script&lang=ts&"
export * from "./AnalyticalTransferReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports